import axios from "axios";
import i18n from "../../i18n";

const actions = {
  getAllEmployees(context) {
    context.commit("SET_ALL_EMPLOYEES");
    return axios
      .get("employee?sort=name")
      .then(function (r) {
        context.commit("SET_ALL_EMPLOYEES", r.data.data);
        return r.data.data;
      })
      .catch(function (e) {
        context.commit("SET_ALL_EMPLOYEES", e);
        context.dispatch("triggerError", e);
      });
  },

  createEmployee(context, value) {
    return axios
      .post("employee", value)
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("employee.createdMessage", { name: r.data.name }),
        );
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  deleteEmployee(context, val) {
    return axios
      .delete("employee/" + val._id)
      .then(function (res) {
        context.commit("CREATE_SNACKBAR", i18n.t("employee.deletedMessage"));
        return res;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },
  bulkAddEmployeeTags(context, { employeeIds, tags }) {
    return axios
      .post("employee/bulk-tags", { employeeIds, tags })
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("employee.tags.bulkApplied", {
            count: r.data.modified ?? employeeIds.length,
          }),
        );
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
        throw e;
      });
  },
  bulkDeleteEmployees(context, ids) {
    return axios
      .post("employee/bulk-delete", { ids })
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("employee.bulk.deleted", { count: r.data.modified ?? 0 }),
        );
        return r.data.modified ?? 0;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
        throw e;
      });
  },
  bulkArchiveEmployees(context, ids) {
    return axios
      .post("employee/bulk-archive", { ids, archived: true })
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("employee.bulk.archived", { count: r.data.modified ?? 0 }),
        );
        return r.data.modified ?? 0;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
        throw e;
      });
  },
  bulkUnarchiveEmployees(context, ids) {
    return axios
      .post("employee/bulk-archive", { ids, archived: false })
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("employee.bulk.unarchived", { count: r.data.modified ?? 0 }),
        );
        return r.data.modified ?? 0;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
        throw e;
      });
  },
  bulkAssignRole(context, { ids, role, dueDate }) {
    return axios
      .post("employee/bulk-role", { ids, role, dueDate })
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("employee.bulk.roleAssigned", { count: r.data.modified ?? 0 }),
        );
        return r.data.modified ?? 0;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
        throw e;
      });
  },
  updateEmployee(context, value) {
    return axios
      .put("employee/" + value.id, value)
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("employee.updatedMessage", { name: r.data.name }),
        );
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },
  async archiveEmployee(context, value) {
    try {
      const employeeReq = await axios.put("employee/" + value._id, value);

      context.commit(
        "CREATE_SNACKBAR",
        i18n.t("employee.updatedMessage", { name: employeeReq.data.name }),
      );

      return employeeReq.data;
    } catch (e) {
      context.dispatch("triggerError", e);
    }
  },

  getSingleEmployee(context, id) {
    return axios
      .get("employee/" + id)
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  createEmployeeImport(context, value) {
    return axios
      .post("employee/batch", value)
      .then(function (r) {
        context.commit("CREATE_SNACKBAR", i18n.t("employee.importedMessage"));
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  updateEmployeeRole(context, value) {
    return axios
      .put("employee/" + value.employeeId + "/role", value)
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  deleteEmployeeRole(context, value) {
    console.log(value);
    return axios
      .put("employee/" + value._id + "/removeRole", { role: value.role })
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getEmployeeStats(context) {
    return axios
      .get("employee/stats")
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },
};

export default actions;
